import { jsx } from '@emotion/react/jsx-runtime';
import { cx } from '@emotion/css';
import { cloneElementWithCss } from '@nettbureau/styling';
import { Children, isValidElement } from 'react';
import { useObjectRef, useFocusable, mergeProps } from 'react-aria';
import { createComponentWithRef } from '../system/factories.js';
import '@react-aria/utils';
import 'ramda';
import { FocusRing } from './focus-ring.js';
import { useFocus } from './use-focus.js';

/**
 * The focusable component can be wrapped around an element to make it focusable.
 */ const Focusable = createComponentWithRef((props, ref)=>{
    const { children, className, color = 'blue' } = props;
    const focusableRef = useObjectRef(ref);
    const { focusableProps } = useFocusable(props, focusableRef);
    const [{ focusVisible }, { focusProps }] = useFocus(props);
    const child = Children.only(children);
    return /*#__PURE__*/ jsx(FocusRing, {
        color: color,
        focused: focusVisible,
        children: /*#__PURE__*/ isValidElement(child) ? cloneElementWithCss(child, {
            ref: focusableRef,
            className: child.props.className ? cx(child.props.className, className) : className,
            ...mergeProps(focusProps, focusableProps),
            tabIndex: 0
        }) : null
    });
});

export { Focusable };
//# sourceMappingURL=focusable.js.map
